// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1FqaT","calendarButtons":"ClockData_calendarButtons__1qUxR"};